let Cookies;

// console.log("当前环境变量 VUE_APP_ENV:", process.env.VUE_APP_ENV);  // 输出环境变量值，帮助调试

if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 Cookies");
    Cookies = require('js-cookie');  // 从 node_modules 加载 Cookies
    globalThis.Cookies = Cookies;  // 设置为全局对象，便于在其他地方使用
} else {
    // console.log("获取 CDN Cookies");
    Cookies = window.Cookies;  // 从全局对象中获取，依赖于 CDN 加载
}

export default Cookies;
